export default "__VITE_ASSET__xZj7085v__"